import BaseModel from '@/bundles/App/models/BaseModel';
import { Nullable } from '@/utils/types';
import { ExtractionSourceEnum } from '@/bundles/Common/types/extractionSource';
import {
  IAvailabilityIngestion,
  IAvailabilityIngestionDocumentRef,
  IAvailabilityIngestionStatusHistoryItem,
  IAvailabilityExtraction,
  IAvailabilityPropertyResolution,
  IAvailabilityBrokerContactMatch,
  AvailabilityIngestionStatusEnum,
} from '@/bundles/AvailabilityIngestion/types';

export default class AvailabilityIngestion extends BaseModel implements IAvailabilityIngestion {
  _key: string;
  _id: string;
  property_id: Nullable<string>;
  document_ref: IAvailabilityIngestionDocumentRef;
  status: AvailabilityIngestionStatusEnum;
  status_history: IAvailabilityIngestionStatusHistoryItem[];
  extraction: Nullable<IAvailabilityExtraction>;
  created_listing_keys?: string[];
  property_resolution: Nullable<IAvailabilityPropertyResolution>;
  broker_contact_matches?: Nullable<IAvailabilityBrokerContactMatch>[];
  created_property_key?: Nullable<string>;
  extraction_source?: ExtractionSourceEnum;

  constructor (payload: IAvailabilityIngestion) {
    super(payload);
    this._key = payload._key;
    this._id = payload._id;
    this.property_id = payload.property_id ?? null;
    this.document_ref = payload.document_ref;
    this.status = payload.status;
    this.status_history = payload.status_history ?? [];
    this.extraction = payload.extraction ?? null;
    this.created_listing_keys = payload.created_listing_keys ?? [];
    this.property_resolution = payload.property_resolution ?? null;
    this.broker_contact_matches = payload.broker_contact_matches;
    this.created_property_key = payload.created_property_key ?? null;
    this.extraction_source = payload.extraction_source;
  }
}
